<template>
    <div v-if="this.$route.name !== 'Autenticação'" class="vue-modal">
        <div id="authentication-modal" @click.self="SET_SHOW_SIDE_NAV(false)" tabindex="-1" aria-hidden="true" class="w-full h-full flex bg-gray-800/80 overflow-hidden fixed top-0 right-0 left-0 z-20 md:inset-0">
            <aside class="w-64 bg-white h-screen flex flex-col justify-between shadow-md">
                <!-- Topo: Dados do Curso -->
                <router-link to="/" class="w-full flex items-center justify-center m-4 p-4 rounded">
                    <img alt="Vue logo" src="/img/logo.png" class="h-16 bg-transparent">
                </router-link>
                <!-- Navegação Principal -->
                <nav class="flex-1 overflow-y-auto border-t divide-y">
                    <!-- Sumário do Caso (se existir aula com slides) -->
                    <div v-if="this.$route.name === 'Aula' && getAula && getAula.CaseStudy_Slides && getAula.CaseStudy_Slides.length > 0">
                        <ul class="space-y-1 text-sm mb-6 p-3">
                            <li v-for="item in getCaseSummary" :key="item.id">
                                <button @click="goToSlide(item.slideIndex)" class="w-full flex items-center gap-3 rounded-md px-2 py-1 text-gray-600 hover:bg-gray-100 hover:text-black transition text-left" :class="{ 'bg-secondary/10 text-black font-medium': isActiveSlide(item.slideIndex) }">
                                    <div class="flex-1">
                                        <span>{{ item.name }}</span>
                                        <div class="flex gap-1 mt-1">
                                            <span v-if="item.type === 'topic' && item.slideCount" class="inline-flex items-center px-1.5 py-0.5 rounded-full text-xs bg-gray-100 text-gray-600">
                                                {{ item.slideCount }} slide{{ item.slideCount > 1 ? 's' : '' }}
                                            </span>
                                            <span v-if="item.commentsCount > 0" class="inline-flex items-center px-1.5 py-0.5 rounded-full text-xs bg-blue-100 text-blue-800">
                                                {{ item.commentsCount }} comentário{{ item.commentsCount > 1 ? 's' : '' }}
                                            </span>
                                        </div>
                                    </div>
                                </button>
                            </li>
                        </ul>
                    </div>
                    <div v-if="getNextAulas && getNextAulas.length" class="pt-6 p-3">
                        <h3 class="mx-2 mb-4 text-xs font-semibold text-gray-400 uppercase">Outros Casos</h3>
                        <ul class="space-y-2 text-sm">
                            <li v-for="aula in getNextAulas.slice(0, 2)" :key="aula.id">
                                <router-link :to="'/aula/' + aula.id" @click="SET_SHOW_SIDE_NAV(false)" class="flex items-center gap-3 rounded-md px-3 py-2 text-gray-600 hover:bg-gray-100 hover:text-black transition">
                                    <div class="w-10 h-8 rounded bg-center bg-cover flex-shrink-0" :style="{ 'background-image': `url('${getThumbnailImage(aula)}')` }">
                                    </div>
                                    <span class="text-xs truncate line-clamp-1"  style="display: -webkit-box; -webkit-line-clamp: 2; overflow: hidden;white-space: normal; -webkit-box-orient: vertical;">
                                        {{ aula.nome }}
                                    </span>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </nav>
                <!-- Rodapé: Próximas Disciplinas -->
                <div v-if="getNextSubjects && getNextSubjects.lenght" class="p-4 border-t">
                    <h3 class="my-4 text-xs font-semibold text-gray-400 uppercase mb-2">Próximas Disciplinas</h3>
                    <ul class="space-y-2 text-sm">
                        <router-link v-for="(subject, index) in getNextSubjects" :key="index" :to="'/subject/' + subject.id" @click="SET_SHOW_SIDE_NAV(false)" class="flex items-center gap-3 rounded-md px-3 py-2 text-gray-400 hover:bg-gray-100 hover:text-black transition cursor-pointer" :class="{ 'text-gray-600': 0 === index }">
                            <div class="w-3 h-3 border rounded-full" :class="{ 'border-secondary': 0 === index }"></div>
                            <span>{{ subject.nome }}</span>
                        </router-link>
                    </ul>
                </div>
            </aside>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters, mapMutations } from 'vuex';

    export default {
        name: "SideNavComponnent",
        components: {},
        data() {
            return {
            }
        },
        mounted() {
            this.fetchProgressGeneral();
            this.fetchNextSubjects();
            this.fetchCaseSummary();
            if(this.$route.name !== 'Aula') this.fetchSuggestionsAulas();
        },
        methods: {
            ...mapActions(['fetchProgressGeneral', 'fetchNextSubjects', 'fetchCaseSummary', 'fetchSuggestionsAulas']),
            ...mapMutations(['SET_SHOW_SIDE_NAV']),

            activeNavItem(item) {
                return this.$route.path === item.url;
            },
            
            goToSlide(slideIndex) {
                // Usar a action do store para navegar para o slide específico
                this.$store.dispatch('goToSlide', slideIndex);
                this.SET_SHOW_SIDE_NAV(false);
            },
            
            isActiveSlide(slideIndex) {
                const currentSlide = this.$store.getters.getCurrentSlideIndex;
                const caseSummary = this.getCaseSummary;
                
                // Encontrar o item do sumário correspondente
                const summaryItem = caseSummary.find(item => item.slideIndex === slideIndex);
                if (!summaryItem) return false;
                
                if (summaryItem.type === 'topic') {
                    // Para tópicos, verificar se o slide atual está no intervalo
                    const nextItem = caseSummary[caseSummary.indexOf(summaryItem) + 1];
                    const endSlide = nextItem ? nextItem.slideIndex - 1 : (this.getAula?.CaseStudy_Slides?.length - 1 || 0);
                    return currentSlide >= slideIndex && currentSlide <= endSlide;
                }
                
                // Para slides individuais, comparação exata
                return currentSlide === slideIndex;
            },
            
            getThumbnailImage(aula) {
                if (aula.type === 'case_study' && aula.CaseStudy_Slides && aula.CaseStudy_Slides.length > 0) {
                    const firstSlide = aula.CaseStudy_Slides.sort((a, b) => (a.order || 0) - (b.order || 0))[0];
                    if (firstSlide && firstSlide.filename_image) {
                        return `${process.env.VUE_APP_URL_SERVER}/uploads/aulas/${aula.id}/${firstSlide.filename_image}`;
                    }
                }
                return aula.thumbnail_url || '';
            }
        },
        computed: {
            ...mapGetters(['getNextSubjects', 'getAula', 'getCaseSummary', 'getNextAulas']),
        },
        
        watch: {
            getAula: {
                handler(newAula) {
                    if (newAula && newAula.CaseStudy_Slides) {
                        this.fetchCaseSummary();
                        this.fetchSuggestionsAulas();
                    }
                },
                immediate: true
            }
        }
    }
</script>